/** Wall-clock idle time before automatic logout (TC-AUT-001). */
export const INACTIVITY_LOGOUT_MS = 15 * 60 * 1000;

/** Show warning this many ms before logout — 14 minutes idle (TC-AUT-002). */
export const INACTIVITY_WARNING_MS = 14 * 60 * 1000;
